import { render, staticRenderFns } from "./PriceSetting.vue?vue&type=template&id=63b7e945&scoped=true"
import script from "./PriceSetting.vue?vue&type=script&lang=js"
export * from "./PriceSetting.vue?vue&type=script&lang=js"
import style0 from "./PriceSetting.vue?vue&type=style&index=0&id=63b7e945&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b7e945",
  null
  
)

export default component.exports